<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "Check"
}
</script>

<style scoped>

</style>